<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>Reservations web</b-card-title>
      <b-card-text class="font-small-2 mr-25 mb-0">
        30 dernières reservations du module de reservations
      </b-card-text>
    </b-card-header>
    <b-card-body >
		<vue-good-table
			:columns="columnslog"
			:rows="rowslog"
			:pagination-options="{
			enabled: true,
			mode: 'records',
			perPage: 5,
			position: 'top',
			perPageDropdown: [5, 10, 20],
			dropdownAllowAll: false,
			jumpFirstOrLast : true,
			firstLabel : 'Première Page',
			lastLabel : 'Dernière Page',
			nextLabel: 'Suivant',
			prevLabel: 'Précédent',
			rowsPerPageLabel: 'ligne par page',
			ofLabel: 'de',
			pageLabel: 'page', // for 'pages' mode
			allLabel: 'Tout',
			infoFn: (params) => `my own page ${params.firstRecordOnPage}`, 
			}"
		>
		  <template
			slot="table-row"
			slot-scope="props"
		  >
			<span
				v-if="props.column.field === 'I_dispo' && props.row.I_dispo != 0"
				style="font-weight: bold; color: blue;"
			>
					{{ props.row.I_dispo }}
			</span>
			<span v-else>
			  {{ props.formattedRow[props.column.field] }}
			</span>
		  </template>
		</vue-good-table>
	</b-card-body>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
	
export default {
	components: {
		BCard,
		BCardHeader,
		BCardTitle,
		BCardText,
		BCardBody,
		VueGoodTable,
	},
	data() {
		return {
			columnslog: [
				{
					label: 'Date',
					field: 'C_date',
				},
				{
					label: 'Société',
					field: 'C_rs',
				},
				{
				  label: 'Version',
				  field: 'I_version',
				},
				{
				  label: 'Etat',
				  field: 'I_etat',
				},
				{
				  label: 'Dispo',
				  field: 'I_dispo',
				},
				{
				  label: 'E-mail',
				  field: 'C_email',
				},
			],
			rowslog: [],
		}
	},
	created() {
		this.$http.get('/admin/lstresa')
		.then(response => { this.rowslog = response.data.Resultresa })
	},	
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
